import type { SetlistContext } from './client';

import { CONTRIBUTORS_COLLECTION } from './collections';
import type { ContributorDocument } from './contributor-documents';
import { escapeTypesenseContributorName } from './contributor-filters';

// Published-asset count for a contributor within one library, read from the
// per-asset-type row on contributors.v1 (`asset_count`, indexed by DEV-6303).
// Returns null when the row or field is missing so callers can hide the count
// rather than render a fake zero.
export const getContributorAssetCount = async (
  context: SetlistContext,
  name: string,
  assetType: 'music' | 'sfx'
): Promise<number | null> => {
  const escaped = escapeTypesenseContributorName(name);
  if (!escaped) {
    return null;
  }

  try {
    const response = await context.client
      .collections<ContributorDocument>(CONTRIBUTORS_COLLECTION)
      .documents()
      .search(
        {
          q: '*',
          query_by: 'name',
          filter_by: `name:=\`${escaped}\` && contributor_type:=${assetType}`,
          per_page: 1,
          include_fields: 'asset_count',
        },
        { cacheSearchResultsForSeconds: 300 }
      );

    const count = response.hits?.[0]?.document?.asset_count;
    return typeof count === 'number' ? count : null;
  } catch (error) {
    context.onError(error, {
      operation: 'getContributorAssetCount',
      assetType,
    });
    return null;
  }
};
